function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-translate';
import { Button, FormControl, Alert } from 'react-bootstrap';
import { actions as commentsActions } from '../redux/comments';
import Mask from '../components/Mask';
import Comments from '../containers/Comments';
import { provideMapState } from 'react-openlayers';
import { recaptchaSiteKey } from '../utils/article';
import './ArticleComments.scss';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, commentsActions), dispatch);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userComment: state.comments.userComment,
    publishing: state.comments.publishing,
    publishError: state.comments.publishError
  };
};

export var ArticleComments = function (_React$Component) {
  _inherits(ArticleComments, _React$Component);

  function ArticleComments() {
    _classCallCheck(this, ArticleComments);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      commentFormExpanded: false,
      commentBodyStyle: undefined,
      displayNameStyle: undefined
    };
    return _this;
  }

  ArticleComments.prototype.initCaptcha = function initCaptcha() {
    if (window.grecaptcha) {
      this.captchaWidget = grecaptcha.render('commentRecaptcha', {
        sitekey: recaptchaSiteKey()
      });
    } else {
      console.warn('No captcha present');
    }
  };

  ArticleComments.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.setUserCommentBody('');
    this.props.clearCommentPublishError();
  };

  ArticleComments.prototype.publish = function publish() {
    var _props = this.props,
        publishComment = _props.publishComment,
        userComment = _props.userComment;
    var comment = userComment.comment,
        displayName = userComment.displayName;

    if (!comment || !displayName) {
      if (!comment) {
        this.setState({
          commentBodyStyle: 'error'
        });
      }

      if (!displayName) {
        this.setState({
          displayNameStyle: 'error'
        });
      }

      return;
    }

    var captcha = grecaptcha.getResponse(this.captchaWidget);
    publishComment(captcha);
    grecaptcha.reset(this.captchaWidget);
  };

  ArticleComments.prototype.renderCommentForm = function renderCommentForm() {
    var _this2 = this;

    var _state = this.state,
        commentBodyStyle = _state.commentBodyStyle,
        displayNameStyle = _state.displayNameStyle;
    var _props2 = this.props,
        t = _props2.t,
        publishing = _props2.publishing,
        publishError = _props2.publishError,
        userComment = _props2.userComment,
        setUserCommentBody = _props2.setUserCommentBody,
        setUserCommentDisplayName = _props2.setUserCommentDisplayName,
        setUserCommentEmail = _props2.setUserCommentEmail;
    var comment = userComment.comment,
        displayName = userComment.displayName,
        email = userComment.email;
    return React.createElement('form', {
      className: ['article-comments--form', 'clearfix', this.state.commentFormExpanded ? 'article-comments--expanded' : ''].join(' ')
    }, publishError && React.createElement(Alert, {
      bsStyle: 'danger'
    }, t('CouldNotPostComment')), React.createElement(FormControl, {
      componentClass: 'textarea',
      bsStyle: commentBodyStyle,
      value: comment,
      onFocus: function onFocus() {
        if (_this2.captchaWidget === undefined) {
          _this2.initCaptcha();
        }

        _this2.setState({
          commentFormExpanded: true
        });
      },
      onChange: function onChange(e) {
        _this2.setState({
          commentBodyStyle: ''
        });

        setUserCommentBody(e.target.value);
      },
      placeholder: t('Comment'),
      className: 'article-comments--commentBody'
    }), React.createElement(FormControl, {
      type: 'text',
      bsStyle: displayNameStyle,
      value: displayName,
      onChange: function onChange(e) {
        _this2.setState({
          displayNameStyle: ''
        });

        setUserCommentDisplayName(e.target.value);
      },
      placeholder: t('DisplayName')
    }), React.createElement(FormControl, {
      type: 'email',
      value: email,
      onChange: function onChange(e) {
        return setUserCommentEmail(e.target.value);
      },
      placeholder: t('Email')
    }), React.createElement('div', {
      id: 'commentRecaptcha',
      className: 'article-comments--captcha'
    }), React.createElement(Button, {
      bsStyle: 'primary',
      onClick: function onClick() {
        return _this2.publish();
      }
    }, t('Submit')), React.createElement('a', {
      onClick: function onClick() {
        return _this2.setState({
          commentFormExpanded: false
        });
      }
    }, t('Hide')), React.createElement(Mask, {
      show: publishing,
      maskText: t('Publishing')
    }));
  };

  ArticleComments.prototype.render = function render() {
    var _props3 = this.props,
        loading = _props3.loading,
        id = _props3.id,
        openArticle = _props3.openArticle;
    return React.createElement('div', {
      className: ['article-comments--window', loading ? 'loading' : ''].join(' ')
    }, this.renderCommentForm(), React.createElement(Comments, {
      id: id,
      openArticle: openArticle
    }));
  };

  return ArticleComments;
}(React.Component);
ArticleComments.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  userComment: PropTypes.object,
  publishing: PropTypes.bool,
  publishError: PropTypes.bool,
  publishComment: PropTypes.func.isRequired,
  setUserCommentBody: PropTypes.func.isRequired,
  setUserCommentDisplayName: PropTypes.func.isRequired,
  setUserCommentEmail: PropTypes.func.isRequired,
  clearCommentPublishError: PropTypes.func.isRequired,
  mapCenter: PropTypes.any,
  mapZoom: PropTypes.number,
  mapExtent: PropTypes.array,
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  openArticle: PropTypes.func.isRequired
} : {};
export default translate('ArticleComments')(connect(mapStateToProps, mapDispatchToProps)(provideMapState(ArticleComments)));